var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_122557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24972 16.1703C1.74968 16.0714 1.42441 15.5858 1.52345 15.0856C1.72864 14.049 2.64385 13.2995 3.70077 13.301C4.92329 13.3028 5.91569 14.2981 5.91392 15.5206C5.91387 15.5594 5.91138 15.5986 5.90623 15.638L5.8812 15.8315L5.88108 15.8325C5.877 15.8646 5.87128 15.8954 5.86439 15.9249C5.75674 16.3858 5.51823 16.8628 5.1821 17.3416C4.87265 17.7823 4.60995 18.1482 4.38854 18.4515C4.65167 18.4499 4.92405 18.4476 5.18876 18.4447C5.69989 18.4382 6.11684 18.8487 6.12249 19.3574C6.12815 19.8671 5.71958 20.2851 5.20975 20.2907C4.4867 20.2988 3.9598 20.3017 3.57409 20.3011C2.65193 20.2998 2.48398 20.2826 2.33085 20.2313C2.04002 20.1339 1.81157 19.9075 1.72007 19.6085C1.68771 19.5028 1.66769 19.3855 1.67726 19.257C1.68684 19.1284 1.72404 19.0154 1.77184 18.9157C1.85036 18.752 1.98329 18.5787 2.11698 18.4045C2.12522 18.3937 2.13347 18.383 2.1417 18.3722L2.1432 18.3703C2.39876 18.0366 2.87391 17.4162 3.67107 16.2807C3.88647 15.974 4.00642 15.7271 4.05701 15.5426L4.06552 15.4768C4.04526 15.2923 3.88773 15.1474 3.69804 15.1471C3.52122 15.1469 3.36823 15.2732 3.33444 15.444C3.23546 15.9442 2.74954 16.2691 2.24972 16.1703ZM3.44687 5.62094L3.28966 5.62071C2.77987 5.61997 2.36718 5.20609 2.36792 4.6963C2.36866 4.1865 2.78254 3.77382 3.29234 3.77455L4.37262 3.77612C4.88242 3.77686 5.2951 4.19074 5.29436 4.70053L5.28704 9.75471C5.2863 10.2645 4.87242 10.6772 4.36263 10.6765C3.85283 10.6757 3.44015 10.2618 3.44089 9.75204L3.44687 5.62094Z",
    fill: "#858E99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5486 5.21422L9.97287 5.23815L9.97971 9.11693L23.5554 9.093L23.5486 5.21422ZM9.96945 3.29876C8.89836 3.30065 8.03159 4.17048 8.03348 5.24157L8.04032 9.12035C8.04221 10.1915 8.91204 11.0582 9.98313 11.0563L23.5589 11.0324C24.63 11.0305 25.4967 10.1607 25.4948 9.08958L25.488 5.2108C25.4861 4.1397 24.6163 3.27294 23.5452 3.27483L9.96945 3.29876Z",
    fill: "#858E99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5657 14.9112L9.98997 14.9351L9.99681 18.8139L23.5725 18.79L23.5657 14.9112ZM9.98655 12.9957C8.91545 12.9976 8.04869 13.8674 8.05058 14.9385L8.05742 18.8173C8.05931 19.8884 8.92913 20.7552 10.0002 20.7533L23.576 20.7293C24.6471 20.7275 25.5138 19.8576 25.5119 18.7865L25.5051 14.9078C25.5032 13.8367 24.6334 12.9699 23.5623 12.9718L9.98655 12.9957Z",
    fill: "#858E99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_122557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.97876 0.0421143) rotate(-0.101015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonList);
export default __webpack_public_path__ + "static/media/ButtonList.8b26e02d474c00766234ef6c804bdb3a.svg";
export { ForwardRef as ReactComponent };